import './GridView.css'

export interface IGridViewParams {
    title: string
    children: React.ReactNode,
    headerRightAlignedItem?: React.ReactNode
}
const GridView: React.FC<IGridViewParams> = ({ children, title, headerRightAlignedItem }) => {
    return (
        <>
            <div className='row d-flex mb-4 gridview'>
                <div className='m-2'>
                    {/* No fixed height on the right-aligned slot: it can hold a
                        48px more-options trigger (ClinicInfo), which a 22px box
                        would spill out of. */}
                    <div className="row m-3 align-items-center">
                        <div className='col gridview-header'>
                            {title}
                        </div>
                        {
                            headerRightAlignedItem &&
                            <div className='col-2 d-flex justify-content-end extra-text-right'>
                                {headerRightAlignedItem}
                            </div>
                        }
                    </div>

                    <hr className="ds-text-primary ds-divider" />
                    <div className="m-3">
                        {children}
                    </div>
                </div>

            </div>
        </>
    )
}
export default GridView; 